module.exports = new __parcel__URL__("lettuce.39b86ec6.svg").toString();